// 商品詳細ページのメインビジュアル
function initDetailSlide() {
  // メインスライダーの初期化
  const slider = new Swiper('#js-product-detail__swiper', {
    // メインスライダーのオプション
  });

  // サムネイルのクリックイベントを設定
  document.querySelectorAll('.js-product-detail__thumb-item').forEach((element) => {
    element.addEventListener('click', function () {
      document.querySelectorAll('.js-product-detail__thumb-item').forEach((el) => {
        el.classList.remove('is-active');
      });
      this.classList.add('is-active');

      // スライダーを適切なスライドに移動
      const slideIndex = parseInt(this.getAttribute('data-slide-index'));
      slider.slideTo(slideIndex);
    });
  });
}


// 商品詳細ページのフロートカート
function initFloatCart() {
  const productDetail = document.querySelector('#js-product__detail');
  const floatCart = document.querySelector('#js-product__detail-float-cart');

  if (!productDetail || !floatCart) return;

  let ticking = false;

  function updateFloatCartPosition() {
    const productDetailRect = productDetail.getBoundingClientRect();
    if (window.innerWidth >= 768) {
      const productDetailTop = window.scrollY + productDetailRect.top;
      const productDetailBottom = window.scrollY + productDetailRect.bottom;
      const floatCartHeight = floatCart.offsetHeight;
      if (window.scrollY >= productDetailTop) {
        const maxScroll = productDetailBottom - floatCartHeight;
        if (window.scrollY < maxScroll) {
          const translateY = window.scrollY - productDetailTop;
          floatCart.style.transform = 'translateY(' + translateY + 'px)';
        } else {
          floatCart.style.transform = 'translateY(' + (productDetailBottom - productDetailTop - floatCartHeight) + 'px)';
        }
      } else {
        floatCart.style.transform = 'none';
      }
    } else {
      const actionElement = document.querySelector('#js-detail-product__action');
      if (actionElement) {
        const actionRect = actionElement.getBoundingClientRect();
        const floatCartStyle = getComputedStyle(floatCart);
        const floatCartBottom = floatCartStyle.getPropertyValue('bottom');
        const floatCartBottomValue = parseInt(floatCartBottom, 10);
        if (actionRect.bottom < 0 && (productDetailRect.bottom + floatCartBottomValue) > window.innerHeight) {
          floatCart.style.transform = 'translateX(0)';
        } else {
          floatCart.style.transform = 'translateX(100%)';
        }
      }
    }
    ticking = false;
  }

  window.addEventListener('scroll', () => {
    if (!ticking) {
      requestAnimationFrame(updateFloatCartPosition);
      ticking = true;
    }
  });

  // 初期状態でのスクロール位置のチェック
  if (window.innerWidth >= 768) {
    if (window.scrollY > 0) {
      updateFloatCartPosition();
    }
  } else {
    updateFloatCartPosition();
  }
}

// アコーディオン
class Accordion {
  constructor(accordionElement) {
    this.accordionElement = accordionElement;
    this.buttonElement = accordionElement.querySelector(".js-accordion__trigger");
    this.contentElement = accordionElement.querySelector(".js-accordion__content");
    this.isOpen = false;
    this.buttonElement.addEventListener("click", () => {
      this.toggleAccordion();
    });
  }
  toggleAccordion() {
    this.isOpen = !this.isOpen;
    this.accordionElement.classList.toggle("is-active", this.isOpen);
    if (this.isOpen) {
      this.contentElement.style.maxHeight = this.contentElement.scrollHeight + "px";
    } else {
      this.contentElement.style.maxHeight = null;
    }
  }
}
function initAccordions() {
  const accordions = document.querySelectorAll(".js-accordion");
  accordions.forEach(accordionElement => {
    new Accordion(accordionElement);
  });
}

function initModal() {
  $('#js-product-detail__set-item-picture-modal').modaal({
    type: 'image',
    custom_class: 'p-product-detail__set-item-picture-modal',
  });
}

function initYouTubeCoverClick() {
  const moviePicture = document.getElementById("js-product-block__movie-picture");
  const youtubeVideo = document.querySelector("iframe");

  if (moviePicture && youtubeVideo) {
    moviePicture.addEventListener("click", () => {
      // moviePicture要素を非表示にする
      moviePicture.style.display = 'none';

      // YouTube動画を表示し、自動再生を開始する
      youtubeVideo.style.display = 'block';
      youtubeVideo.src += (youtubeVideo.src.includes('?') ? '&' : '?') + "autoplay=1";
    });
  }
}



/* ---------------------------------------------------------------------
DOMContentLoaded
--------------------------------------------------------------------- */
document.addEventListener('DOMContentLoaded', () => {
  // ここに処理関数を記述
  initDetailSlide();
  initFloatCart();
  initAccordions();
  initModal();
  initYouTubeCoverClick();
});

/* ---------------------------------------------------------------------
resize
--------------------------------------------------------------------- */
let currentWidth = window.innerWidth;
let resizeTimer = null;

window.addEventListener('resize', () => {
  if (currentWidth === window.innerWidth) return;
  if (resizeTimer) {
    clearTimeout(resizeTimer);
  }
  resizeTimer = setTimeout(() => {
    // ここに処理関数を記述
    currentWidth = window.innerWidth;
  }, 200);
});